import React, { useState, useContext, useEffect } from 'react';
import { Detail as DetailComponent, Confirm, useDrawer, SplitButton } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadOne } from "src/mtska-frontend-data-provider/hooks/useLoadOne.hooks";
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';

const dataProviderName = 'renters/manageableinstalled';

const Detail = (params) => {
    const { t } = useTranslation();
    const { userCapabilities, existingModules } = useContext(AppContext);

    const { close: closeDrawer } = useDrawer();

    // DATA PROVIDER
    const { item, save, doAction, loadOne, destroy, errorMessage, errors, saving, success, reloadCounter } = useDataProvider(dataProviderName, params.multipart);

    const { modelName, detailConfig } = existingModules[dataProviderName]
    const [localDetailConfig, setLocalDetailConfig] = useState();
    const onSuccess = (resp) => {
        if (typeof resp?.item?.detailConfig == 'object') {
            const pd = populateActions(resp.item.detailConfig);
            setLocalDetailConfig(pd);
        } else {
            const dc = populateActions(detailConfig);
            setLocalDetailConfig(dc);
        }
    }
    useLoadOne({ loadOne, params, reloadCounter, onSuccess })

    const [editing, setEditing] = useState(false);
    const [localError, setLocalError] = useState();

    const handleSave = (data) => {
        save({ ...data, filters: params.filters, canReloadCounter: false }).then((data) => params.handleClose(params.uid, data.item.data)).catch(() => console.error('catch handleSave'));
    }

    const [confirmDelete, setConfirmDelete] = useState();
    const handleDelete = (id) => {
        setConfirmDelete(
            <Confirm
                oklabel={t("Delete")}
                okcallable={() => {
                    destroy && destroy(id);
                    closeDrawer();
                }}
                kolabel={t("Cancel")}
                kocallable={() => { setConfirmDelete(null) }}
                title={t("Item elimination")}>
                {t("Are you sure to remove this element?")}
            </Confirm>
        );
    }

    // Negli step in avanti salvo il modello, scatenando la validazione server side
    // Allo step finale, scateno la sincronizzazione
    // negli step indietro non faccio nulla
    const onProcessStepAction = (currentStep, stepTotal, actionInvoked, getValues) => {
        //console.info('onProcessStepAction currentStep:', currentStep, 'stepTotal:', stepTotal, 'actionInvoked:', actionInvoked, getValues());
        setLocalError();
        const values = getValues();

        if (actionInvoked > 0 && (currentStep + 1) < stepTotal) {
            const data = getValues();
            return save({ ...data, ...{ forceDetect: true } })
        } else if (actionInvoked > 0 && (currentStep + 1) == stepTotal && values['submit_actions'] == undefined) {
            setLocalError("Seleziona un'azione da compiere");
        } else if (actionInvoked > 0 && (currentStep + 1) == stepTotal && values['submit_actions'] != undefined) {
            const payload = {
                "action": "applyAction",
                "model": dataProviderName,
                "model_ids": [values['_id']],
                "data": {
                    "action": values['submit_actions'],
                    "model_ids": [values['_id']]
                }
            }

            if (values['submit_actions'] === 'manual') {
                payload.data.finalData = values.finalData;
            }

            doAction(payload).then(() => { params.handleClose(params.uid) }).catch((e) => console.error('catch handleSave', e));
        } else {
            return true;
        }
    }

    const populateActions = (target) => {
        console.log("target.steps", target.steps)
        const availableActions = item?.data?.synchronizer?.actions?.actions?.split(',') ?? [];
        const targetField = target.steps[1].columns[0].tabs[0].fieldsets[0].fields['submit_actions'];
        targetField['options'] = availableActions.map(itm => { return { label: itm, value: itm } })

        return target;
    }

    // nei primi step, verifico se posso passare allo step successivo
    const onValidateStepAction = (currentStep, getValues, setValue, setError, resultValue) => {

        if (currentStep == 0) {
            // a prescindere dal risultato passo al successivo stage dove ho la correzione
            return true;
        } else if (currentStep == 1 && resultValue.type == 'SAVE_FAILURE') {
            return false;
        } else if (currentStep == 1) {
            // popolo la lista delle azioni disponibili per l'ordine
            populateActions(localDetailConfig);
            return true;
        } else {
            return true;
        }
    }

    const onChangeFieldValueAction = (field, value, setFormValues, stepActive, setValue, getValues) => {

        //console.info('++++ onChangeFieldValueAction: Valuto cosa fare ', field, value)
        if (field === 'submit_actions') {
            //console.info('<<<Richiedo dryrun per ', value)
            loadOne(params.id, { action: value }).then((result) => {
                //console.info('>>>Ricevo dryrun per ', value)
                if (result?.item?.data) {
                    result.item.data.submit_actions = value;
                    setFormValues(result.item.data);
                }
            });
        } else if (field == 'finalData' && stepActive == 2) {
            //console.info('>>>> Cambio e metto manuale', field, stepActive)
            setValue('submit_actions', 'manual');
        }
    }

    return (
        <>
            {
                localDetailConfig &&
                <>
                    <DetailComponent
                        values={{ ...item?.data }}
                        modelName={modelName}
                        detailConfig={localDetailConfig}
                        onEditing={setEditing}
                        save={handleSave}
                        saving={saving}
                        errors={errors}
                        errorMessage={errorMessage}
                        alertMessage={localError}
                        canSave={userCapabilities && userCapabilities[dataProviderName + '.edit']}
                        title={t('Renter Installed Management')}
                        subtitle={item?.data?.orderIdentifier ? t('Order Identifier') + ' ' + item?.data?.orderIdentifier : ''}
                        rightButtons={[
                            <SplitButton
                                actions={[
                                    {
                                        disabled: userCapabilities && !userCapabilities[dataProviderName + '.delete'],
                                        icon: "faTrash",
                                        label: t('Delete'),
                                        onClick: () => { handleDelete(item.data.id); }
                                    }
                                ]}
                            />
                        ]}
                        onProcessStepAction={onProcessStepAction}
                        onValidateStepAction={onValidateStepAction}
                        onChangeFieldValueAction={onChangeFieldValueAction}
                        {...params}
                    />
                </>
            }


            {confirmDelete}
        </>
    )
}

export default Detail;


